import { Menu, X } from 'lucide-react';

import Brand from '../../common/Brand';
import type { HeaderProps } from './useHeader';

const HeaderMobile = ({
  data,
  handleNavClick,
  handleCtaClick,
  toggleMenu,
}: HeaderProps) => {
  return (
    <header className="fixed top-0 z-50 w-full bg-surface-primary">
      <div className="flex items-center justify-between px-4 py-4">
        <Brand link="/" variant="dark" />

        <button
          onClick={toggleMenu}
          aria-label={data.isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={data.isMenuOpen}
          className="cursor-pointer border-none bg-transparent p-2 text-foreground-primary"
        >
          {data.isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {data.isMenuOpen && (
        <nav className="absolute left-0 top-full w-full bg-surface-primary shadow-lg">
          <div className="flex flex-col gap-2 px-4 py-4">
            {data.navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item)}
                className="cursor-pointer border-none bg-transparent py-3 text-left font-body text-[15px] font-medium text-foreground-secondary transition-colors hover:text-foreground-primary"
              >
                {item.label}
              </button>
            ))}

            <button
              onClick={handleCtaClick}
              className="mt-4 w-full cursor-pointer rounded bg-accent-primary px-8 py-3.5 font-body text-sm font-semibold text-surface-inverse transition-colors hover:bg-accent-hover"
            >
              {data.ctaText}
            </button>
          </div>
        </nav>
      )}
    </header>
  );
};

export default HeaderMobile;
